export default __webpack_public_path__ + "static/media/cctv_camera.743d7b49.jpg";